import React from "react";
import {NavLink,Navigate,useLocation, useNavigate} from 'react-router-dom';
import Logo from '../images/logo.png'
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useDispatch } from "react-redux";
import { navbarAction } from "../redux/actions/navActions";
import supabase from "../supabase"

function Header(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logout = async() =>{
        let { error } = await supabase.auth.signOut()
        if(!error){
          localStorage.removeItem("AccessToken")
          navigate('/login');
        }
    }
    return (
      <>
        <Navbar className="header-section">
            <Navbar.Brand className={`${props.addClass}`}>
            <NavLink to="/admin-dashboard"><img src={Logo ? `${Logo}` : `${Logo}`} className="logo-size" /></NavLink>
            </Navbar.Brand>
            <Nav className="me-auto">
              <Nav.Link onClick={()=>{dispatch(navbarAction())}} className="toggle_button"><i className="fa fa-bars"></i></Nav.Link>
            </Nav>
            <Nav className="ms-auto">
              <DropdownButton id="dropdown-basic-button" title="Logicode" className="header-profile">
                  <Dropdown.Item eventKey="4" onClick={logout}><i className="fa fa-sign-out"></i> Logout</Dropdown.Item>
              </DropdownButton>
            </Nav>
        </Navbar>
      </>
    );
}

export default Header;
